import { useEffect, useState } from "react";
import { Box, Checkbox, FormControlLabel, Typography, makeStyles } from "@material-ui/core"
import NumberInputField from "../ui/NumberInputField";

export interface Quantifiable {
  id: number;
  quantity: number;
  limit: number;
}

export interface PackageElement extends Quantifiable {
  name: string;
}

interface Props {
  availablePackageElement: PackageElement;
  selectedPackageElement?: PackageElement;
  onPackageElementQuantityChanged: (packageElement: PackageElement, quantity: number) => void;
}

const useStyles = makeStyles(theme => ({
  element: {
    display: 'flex',
    flexDirection: 'row'
  },
  inputField: {
    padding: 0,
    marginTop: theme.spacing(0.6),
    width: theme.spacing(3)
  },
  availableQuantity: {
    padding: 0,
    marginTop: theme.spacing(1),
  }
}));

const KitPackageElement = (props: Props) => {
  const classes = useStyles();
  const availablePackageElement = props.availablePackageElement;
  const selectedPackageElement = props.selectedPackageElement;
  const [isPackageElementSelected, setPackageElementSelected] = useState(selectedPackageElement !== undefined);
  const selectedQuantity = selectedPackageElement?.quantity || 0;
  const elementsPackedTotal = availablePackageElement.quantity + selectedQuantity;
  const totalQuantityAvailable = availablePackageElement.limit;
  const availableQuantity = totalQuantityAvailable - availablePackageElement.quantity;

  const handlePackageElementSelectionChanged = (packageElement: PackageElement, checked: boolean) => {
    console.info(`## KitPackageElement.handlePackageElementSelectionChanged[${availablePackageElement.name}] = ${checked}`);
    setPackageElementSelected(checked);
    props.onPackageElementQuantityChanged(packageElement, 0);
  };

  const handlePackageElementQuantityChanged = (packageElement: PackageElement, quantity: number) => {
    console.info(`## KitPackageElement.handlePackageElementQuantityChanged[${availablePackageElement.name}] = ${quantity}`);
    props.onPackageElementQuantityChanged(packageElement, quantity);
  };

  useEffect(() => {
    console.info(`## selectedPackageElement[${availablePackageElement.name}] = ${JSON.stringify(selectedPackageElement)}`);
  }, [selectedPackageElement]);

  return <Box className={ classes.element }>
    <FormControlLabel
      label={<Typography noWrap>
        {`${availablePackageElement.name} [${elementsPackedTotal}/${availablePackageElement.limit}]`}
      </Typography>}
      control={<Checkbox
        checked={ isPackageElementSelected }
        onChange={ (event, checked) => handlePackageElementSelectionChanged(availablePackageElement, checked) }
      />}
    />
    <NumberInputField
      classes={ classes }
      initialValue={ selectedPackageElement?.quantity || 0 }
      calculatedValue={ selectedPackageElement?.quantity }
      onValueChange={ quantity => handlePackageElementQuantityChanged(availablePackageElement, quantity) }
      errorMessage={ () => elementsPackedTotal === totalQuantityAvailable ? null : '' }
      disabled={ !isPackageElementSelected }
    />
    <Typography className={ classes.availableQuantity }>{`z ${Math.max(availableQuantity, 0)}`}</Typography>
  </Box>
};

export default KitPackageElement;